// extracted by mini-css-extract-plugin
module.exports = {"buttonMore":"style_buttonMore__1KL3M","box":"style_box__135B5","deletePrompt":"style_deletePrompt__21HIA"};